<template>
  <div>
    <div class="addFormBox">
      <!--基础数据-->
      <div class="basicForm">
        <div class="title">{{ $t('basicData.UnderlyingData') }}</div>
        <el-form
          :key="exportKey"
          ref="queryForm"
          :model="formData"
          :rules="rules"
          class="queryFormClass"
          label-position="top"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <!--报价方案名称-->
              <el-form-item :label="$t('basicData.TheNameOfTheQuoteProposal')" prop="name">
                <el-input
                  v-model.trim="formData.name"
                  :placeholder="$t('orderDetails.pleaseInput')"
                  clearable
                  maxlength="100"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--有效期开始-->
              <el-form-item :label="$t('basicData.TheValidityPeriodBegins')" prop="startTime">
                <el-date-picker
                  v-model="formData.startTime"
                  :disabled="isDataDisabled"
                  :format="isZh"
                  :placeholder="$t('basicData.SelectADatetime')"
                  style="width: 100%;"
                  type="datetime"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--业务类型-->
              <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
                <el-select
                  v-model="formData.businessType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%;"
                  @change="changeBusinessType(1)"
                >
                  <el-option
                    v-for="item in BUSINESS_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col v-if="formData.businessType === 1" :span="6">
              <!--揽收类型-->
              <el-form-item
                :label="$t('basicData.CollectionType')"
                prop="collectionCategory"
                :rules="{ required: formData.businessType === 1, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <el-select
                  v-model="formData.collectionCategory"
                  :placeholder="$t('basicData.PleaseSelect')"
                  filterable
                  style="width: 100%;"
                  @change="changeBusinessType(2)"
                >
                  <!--普通揽收-->
                  <el-option :label="$t('basicData.OrdinaryPickUp')" :value="0" />
                  <!--备货揽收-->
                  <el-option :label="$t('basicData.StockingAndPickup')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <!--          非整车业务-->
            <el-col v-if="formData.businessType !== 8" :span="6">
              <!--分区方案名称-->
              <el-form-item :label="$t('basicData.PartitionSchemeName')" prop="partitionId">
                <el-select
                  v-model="formData.partitionId"
                  :placeholder="$t('basicData.PleaseSelect')"
                  filterable
                  style="width: 100%;"
                  @change="getOtherFeeDetail"
                >
                  <el-option
                    v-for="item in partitionList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--报价类型-->
              <el-form-item :label="$t('basicData.QuoteType')" prop="offerType">
                <el-select
                  v-model="formData.offerType"
                  :placeholder="$t('basicData.PleaseSelect')"
                  style="width: 100%;"
                  @change="offerTypeChange"
                >
                  <el-option
                    v-for="item in QUOTE_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="isOptionDisabled(item.value, 1)"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--报价模式-->
              <el-form-item :label="$t('receivablePayable.quotationMode')" prop="offerMode">
                <el-select
                  v-model="formData.offerMode"
                  :placeholder="$t('basicData.PleaseSelect')"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in QUOTE_MODE_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="isOptionDisabled(item.value, 2)"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="[2,3].includes(formData.offerType) && formData.businessType !== 8" :span="6">
              <!--应收主体-->
              <el-form-item :label="$t('basicData.businessPrincipal')" prop="providerInfoId">
                <el-select
                  v-model="formData.providerInfoId"
                  :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                  :remote-method="queryProviderPage"
                  filterable
                  remote
                  reserve-keyword
                  clearable
                  style="width: 100%;"
                  @clear="queryProviderPage"
                  @change="providerInfoChange"
                >
                  <el-option
                    v-for="item in providerList"
                    :key="item.id"
                    :label="`${item.providerBody}（${item.providerName}）（${item.code}）`"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="formData.offerType === 4" :span="6">
              <!--客户-->
              <el-form-item :label="$t('receivablePayable.customer')" prop="customerIds">
                <el-select
                  v-model="formData.customerIds"
                  :multiple="!editData.id"
                  :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                  :remote-method="getCustomerPage"
                  clearable
                  filterable
                  remote
                  reserve-keyword
                  style="width: 100%;"
                  @clear="getCustomerPage"
                  @change="customerChange"
                >
                  <el-option
                    v-for="(item, ind) in customerList"
                    :key="ind"
                    :label="`${formData.businessType === 8 ? '' : item.customerAlias}` + '(' + item.username + ')'"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="formData.offerType === 3" :span="6">
              <!--网点-->
              <el-form-item :label="$t('basicData.Outlets')" prop="siteIds">
                <el-select
                  v-model="formData.siteIds"
                  :multiple="!editData.id"
                  :placeholder="$t('basicData.PleaseSelect')"
                  filterable
                  style="width: 100%;"
                >
                  <el-option v-if="!formData.providerInfoId" value=""><span
                    style="color:#f00;font-weight: bold"
                  >{{ $t('basicData.SelectTheBusinessPrincipalFirst') }}</span>
                  </el-option>
                  <el-option
                    v-for="item in outletsList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="formData.businessType !== 8" :span="6">
              <!--服务类型-->
              <el-form-item :label="$t('newOrder.TypeService')" prop="expressType">
                <el-select
                  v-model="formData.expressType"
                  :placeholder="$t('basicData.PleaseSelect')"
                  style="width: 100%;"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in EXPRESS_TYPE"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="formData.businessType !== 8" :span="6">
              <!--货物类型-->
              <el-form-item :label="$t('placeOrder.cargoType')" prop="cargoType">
                <el-select
                  v-model="formData.cargoType"
                  :placeholder="$t('basicData.PleaseSelect')"
                  style="width: 100%;"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in CARGO_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--账单类型-->
              <el-form-item :label="$t('receivablePayable.billType')" prop="billType">
                <el-select
                  v-model="formData.billType"
                  :placeholder="$t('basicData.PleaseSelect')"
                  style="width: 100%;"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in BILL_TYPE"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 揽收方式  -->
            <el-col v-if="!formData.businessType" :span="6">
              <el-form-item :label="$t('collectionCenter.lanshouTypee')">
                <CollectTypeCmp v-model="formData.collectType" :business-type="formData.businessType" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!--价格详情-->
      <div class="title">{{ $t('basicData.PriceDetails') }}</div>
      <!--分区-->
      <div v-if="formData.businessType !== 8 && formData.partitionId" class="mb10 flex">
        <label class="el-form-item__label" style="width: 120px; line-height: 32px;">{{ $t('basicData.PartitionName') }}：</label>
        <QueryPartVCmp
          :val="formData.partitionAffiliateId"
          :list="subregionList"
          style="width: 400px;"
          @change="val => formData.partitionAffiliateId = val"
        />
      </div>
      <div v-if="formData.businessType === 8" class="mb10 flex">
        <!-- 车型 -->
        <label class="el-form-item__label" style="width: 120px; line-height: 32px;">{{ $t('vehicle.modelLabel') }}：</label>
        <el-select
          v-model="formData.partitionAffiliateId"
          :placeholder="$t('basicData.PleaseSelect')"
          style="width: 400px;"
          size="small"
        >
          <el-option
            v-for="item in modelList"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
      </div>

      <div class="priceTableForm">
        <div class="feet-r mb10">
          <!--增加一行-->
          <el-button
            v-permit:remove="'btn:finance:basicData:quotationManagement:add'"
            size="small"
            type="primary"
            @click="handleAdd()"
          >{{ $t('basicData.AddARow') }}
          </el-button>
          <el-popover
            placement="bottom-start"
            trigger="hover"
          >
            <import-download
              :key="exportKey"
              :expense-type-list="expenseTypeList"
              :import-type="1"
              :table-data="{ formData, subregionList, modelList }"
              :table-data-obj="tableDataObj.collectFeesList"
              @importPartition="importPartition"
            />
            <!--导入/下载-->
            <template slot="reference">
              <el-button plain size="small">{{ $t('basicData.ImportDownload') }}</el-button>
            </template>
          </el-popover>
          <!--清空报价-->
          <el-popover
            placement="bottom-start"
            trigger="hover"
          >
            <div class="feet">
              <!--清空当前分区-->
              <el-button
                size="small"
                type="primary"
                @click="clearOffers(1)"
              >{{ $t('basicData.EmptyCurrentPartition') }}
              </el-button>
              <!--清空所有分区-->
              <el-button
                class="feet-btn"
                size="small"
                type="primary"
                @click="clearOffers(2)"
              >{{ $t('basicData.EmptyAllPartitions') }}
              </el-button>
            </div>
            <!--清空报价 v-permit:remove="'btn:finance:basicData:quotationManagement:edit'"-->
            <template slot="reference">
              <el-button plain size="small">{{ $t('basicData.ClearTheOffer') }}</el-button>
            </template>
          </el-popover>
        </div>
        <el-form
          ref="tableForm1"
          :model="formData"
          class="demo-ruleForm"
          :label-width="'0px'"
          size="small"
        >
          <!--普通规则-->
          <div style="margin-bottom: 20px;">
            <!--            <virtual-scroll-->
            <!--              ref="virtualScroll"-->
            <!--              :key="key"-->
            <!--              :data="formData.collectFeesList"-->
            <!--              :item-size="62"-->
            <!--              key-prop="key"-->
            <!--              @change="(virtualList) => collectFeesData = virtualList"-->
            <!--            >-->
            <el-table
              :key="tableKey"
              :data="formData.collectFeesList"
              border
              class="error-table"
            >
              <!-- <virtual-column width="50" type="index" />-->
              <!--普通费用类型-->
              <el-table-column :label="$t('basicData.ExpenseType')" min-width="180">
                <template #header>
                  <div>
                    <span style="color: red;">*</span>
                    <span>{{ $t('basicData.ExpenseType') }}</span>
                  </div>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'collectFeesList.' + scope.$index + '.feeTypeCode'"
                    :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                  >
                    <el-select
                      v-model="scope.row.feeTypeCode"
                      :placeholder="$t('basicData.PleaseSelect')"
                      style="width: 100%;"
                      @change="chargeTypeChange(scope)"
                    >
                      <el-option
                        v-for="item in expenseTypeList"
                        :key="item.id"
                        :label="item.displayName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- 业务类型：0-快递 2-派件 报价模式 1-续重 -->
              <template v-if="[0, 2].includes(formData.businessType) && formData.offerMode === 1">
                <!-- 重量类型-->
                <el-table-column min-width="180">
                  <template #header>
                    <div>
                      <span style="color: red;">*</span>
                      <span>{{ $t('receivablePayable.weightType') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="'collectFeesList.' + scope.$index + '.weightType'"
                      :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                    >
                      <el-select
                        v-model="scope.row.weightType"
                        :placeholder="$t('basicData.PleaseSelect')"
                        style="width: 100%;"
                      >
                        <el-option :label="$t('receivablePayable.initialWeight')" :value="0" />
                        <el-option :label="$t('receivablePayable.renewWeight')" :value="1" />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!--重量开始-->
                <el-table-column min-width="180">
                  <template #header>
                    <div>
                      <span style="color: red;">*</span>
                      <span>{{ $t('receivablePayable.weightStart') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="'collectFeesList.' + scope.$index + '.startWeight'"
                      :rules="{
                        required: true,
                        negative: '',
                        suffix: 3,
                        negative1: 1,
                        package: scope.row.endWeight,
                        validator: priceType,
                        trigger: ['blur', 'change']
                      }"
                    >
                      <el-input v-model.trim="scope.row.startWeight" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!--重量结束-->
                <el-table-column min-width="180">
                  <template #header>
                    <div>
                      <span style="color: red;">*</span>
                      <span>{{ $t('receivablePayable.continuedWeightEnd') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="'collectFeesList.' + scope.$index + '.endWeight'"
                      :rules="{
                        required: true,
                        negative: '',
                        suffix: 3,
                        negative1: 2,
                        package: scope.row.startWeight,
                        validator: priceType,
                        trigger: ['blur', 'change']
                      }"
                    >
                      <el-input v-model.trim="scope.row.endWeight" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!--价格-->
                <el-table-column :label="$t('basicData.Price')" min-width="180">
                  <template #header>
                    <div>
                      <span style="color: red;">*</span>
                      <span>{{ $t('basicData.Price') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="'collectFeesList.' + scope.$index + '.price'"
                      :rules="{ required: true, suffix: 3, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                    >
                      <div style="display: flex;">
                        <div style="flex: 1">
                          <el-input v-model="scope.row.price" />
                        </div>
                        <div style="width: 35px;text-align: right;">/{{ scope.row.weightType === 1 ? 'KG' : $t('basicData.ticket') }}</div>
                      </div>
                    </el-form-item>
                  </template>
                </el-table-column>
              </template>
              <!-- 业务类型：1-揽收 8-整车 【快递-区间价】 -->
              <template v-else>
                <!--计费类型 [备货揽收隐藏] -->
                <el-table-column
                  v-if="formData.collectionCategory !== 1"
                  :label="$t('basicData.chargeType')"
                  min-width="180"
                >
                  <template #header>
                    <div>
                      <span style="color: red;">*</span>
                      <span>{{ $t('basicData.chargeType') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="'collectFeesList.' + scope.$index + '.billingType'"
                      :rules="{ required: !formData.collectionCategory, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                    >
                      <el-select
                        v-model="scope.row.billingType"
                        :placeholder="$t('basicData.PleaseSelect')"
                        style="width: 100%;"
                        @change="chargeTypeChange(scope)"
                      >
                        <el-option v-show="formData.businessType !== 8" :label="$t('newOperationCenter.Weight')" :value="1" />
                        <el-option v-show="formData.businessType !== 8" :label="$t('collectionCenter.ballot')" :value="2" />
                        <el-option v-show="formData.businessType === 8" :label="$t('collectionCenter.distance')" :value="4" />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 揽收方式 【普通揽收显示】-->
                <el-table-column
                  v-if="formData.businessType === 1 && formData.collectionCategory === 0"
                  :label="$t('collectionCenter.lanshouTypee')"
                  min-width="180"
                >
                  <template #header>
                    <div>
                      <span v-if="formData.businessType === 1" style="color: red;">*</span>
                      <span>{{ $t('collectionCenter.lanshouTypee') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="'collectFeesList.' + scope.$index + '.collectType'"
                      :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                    >
                      <el-select
                        v-model="scope.row.collectType"
                        :placeholder="$t('basicData.PleaseSelect')"
                        style="width: 100%;"
                      >
                        <!--上门交件-->
                        <el-option :key="1" :label="$t('collectionCenter.dropOff')" :value="1" />
                        <!--上门揽收-->
                        <el-option :key="2" :label="$t('collectionCenter.doorPickUp')" :value="2" />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 备货揽收-->
                <template v-if="formData.collectionCategory === 1">
                  <!--箱数开始(不包含)-->
                  <el-table-column :label="$t('basicData.BoxCountStartsNotIncluded')" min-width="180">
                    <template #header>
                      <div>
                        <span style="color: red;">*</span>
                        <span>{{ $t('basicData.BoxCountStartsNotIncluded') }}</span>
                      </div>
                    </template>
                    <template v-slot="scope">
                      <el-form-item
                        :prop="'collectFeesList.' + scope.$index + '.startCases'"
                        :rules="{
                          required: true,
                          negative: '',
                          suffix: 2,
                          negative1: 1,
                          package: scope.row.endCases,
                          validator: Integer0,
                          trigger: ['blur', 'change']
                        }"
                      >
                        <el-input v-model.trim="scope.row.startCases" />
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <!--箱数结束(包含)-->
                  <el-table-column :label="$t('basicData.EndOfCaseCountIncluded')" min-width="180">
                    <template #header>
                      <div>
                        <span style="color: red;">*</span>
                        <span>{{ $t('basicData.EndOfCaseCountIncluded') }}</span>
                      </div>
                    </template>
                    <template v-slot="scope">
                      <el-form-item
                        :prop="'collectFeesList.' + scope.$index + '.endCases'"
                        :rules="{
                          required: true,
                          negative: '',
                          suffix: 2,
                          negative1: 2,
                          package: scope.row.startCases,
                          validator: Integer0,
                          trigger: ['blur', 'change']
                        }"
                      >
                        <el-input v-model.trim="scope.row.endCases" />
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <!--价格-->
                  <el-table-column :label="$t('basicData.Price')" min-width="180">
                    <template #header>
                      <div>
                        <span style="color: red;">*</span>
                        <span>{{ $t('basicData.Price') }}</span>
                      </div>
                    </template>
                    <template v-slot="scope">
                      <el-form-item
                        :prop="'collectFeesList.' + scope.$index + '.price'"
                        :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                      >
                        <el-input v-model="scope.row.price" />
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <!--超出价格-->
                  <el-table-column :label="$t('basicData.ExceedingThePrice')" min-width="180">
                    <template #header>
                      <span>{{ $t('basicData.ExceedingThePrice') }}</span>
                    </template>
                    <template v-slot="scope">
                      <el-form-item
                        :prop="'collectFeesList.' + scope.$index + '.overExtraPrice'"
                        :rules="{ required: false, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                      >
                        <el-input v-model="scope.row.overExtraPrice" />
                      </el-form-item>
                    </template>
                  </el-table-column>
                </template>
                <!-- 普通揽收-->
                <template v-else>
                  <!--开始（不包含）-->
                  <el-table-column :label="$t('basicData.Begin')" min-width="240">
                    <template #header>
                      <div>
                        <span style="color: red;">*</span>
                        <span>{{ $t('basicData.Begin') }}</span>
                      </div>
                    </template>
                    <template v-slot="scope">
                      <div v-if="scope.row.billingType === 2">
                        <el-form-item
                          :prop="'collectFeesList.' + scope.$index + '.startWeight'"
                          :rules="{
                            required: false,
                            negative: '',
                            suffix: 2,
                            negative1: 1,
                            package: scope.row.endWeight,
                            validator: priceType,
                            trigger: ['blur', 'change']
                          }"
                        >
                          <div style="display: flex;">
                            <div style="flex: 1">
                              <el-input v-model.trim="scope.row.startWeight" />
                            </div>
                            <div style="width: 35px;text-align: right;">(KG)</div>
                          </div>
                        </el-form-item>
                      </div>
                      <div v-else>
                        <el-form-item
                          :prop="'collectFeesList.' + scope.$index + '.startWeight'"
                          :rules="{
                            required: true,
                            negative: '',
                            suffix: 3,
                            negative1: 1,
                            package: scope.row.endWeight,
                            validator: priceType,
                            trigger: ['blur', 'change']
                          }"
                        >
                          <div style="display: flex;">
                            <div style="flex: 1">
                              <el-input v-model.trim="scope.row.startWeight" />
                            </div>
                            <div style="width: 35px;text-align: right;">(KG)</div>
                          </div>
                        </el-form-item>
                      </div>
                    </template>
                  </el-table-column>
                  <!--结束（包含）-->
                  <el-table-column :label="$t('basicData.end')" min-width="240">
                    <template #header>
                      <div>
                        <span style="color: red;">*</span>
                        <span>{{ $t('basicData.end') }}</span>
                      </div>
                    </template>
                    <template v-slot="scope">
                      <div v-if="scope.row.billingType === 2">
                        <el-form-item
                          :prop="'collectFeesList.' + scope.$index + '.endWeight'"
                          :rules="{
                            required: false,
                            negative: '',
                            suffix: 2,
                            negative1: 2,
                            package: scope.row.startWeight,
                            validator: priceType,
                            trigger: ['blur', 'change']
                          }"
                        >
                          <div style="display: flex;">
                            <div style="flex: 1">
                              <el-input v-model.trim="scope.row.endWeight" />
                            </div>
                            <div style="width: 35px;text-align: right;">(KG)</div>
                          </div>
                        </el-form-item>
                      </div>
                      <div v-else>
                        <el-form-item
                          :prop="'collectFeesList.' + scope.$index + '.endWeight'"
                          :rules="{
                            required: true,
                            negative: '',
                            suffix: 3,
                            negative1: 2,
                            package: scope.row.startWeight,
                            validator: priceType,
                            trigger: ['blur', 'change']
                          }"
                        >
                          <div style="display: flex;">
                            <div style="flex: 1">
                              <el-input v-model.trim="scope.row.endWeight" />
                            </div>
                            <div style="width: 35px;text-align: right;">(KG)</div>
                          </div>
                        </el-form-item>
                      </div>
                    </template>
                  </el-table-column>
                  <!--价格-->
                  <el-table-column :label="$t('basicData.Price')" min-width="180">
                    <template #header>
                      <div>
                        <span style="color: red;">*</span>
                        <span>{{ $t('basicData.Price') }}</span>
                      </div>
                    </template>
                    <template v-slot="scope">
                      <!-- :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }" -->
                      <el-form-item
                        :prop="'collectFeesList.' + scope.$index + '.price'"
                        :rules="rules.price"
                      >
                        <div style="display: flex;">
                          <div style="flex: 1">
                            <el-input v-model.trim="scope.row.price" />
                          </div>
                          <div
                            v-if="scope.row.billingType === 2"
                            :style="{ width: $i18n.locale!=='zh' ? '50px' : '25px' }"
                            style="text-align: right;"
                          >
                            /{{ $t('basicData.ticket') }}
                          </div>
                        </div>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <!--超出价格-->
                  <el-table-column :label="$t('basicData.ExceedingThePrice')" min-width="180">
                    <template #header>
                      <span>{{ $t('basicData.ExceedingThePrice') }}</span>
                    </template>
                    <template v-slot="scope">
                      <!-- :rules="{ required: false, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }" -->
                      <el-form-item
                        :prop="'collectFeesList.' + scope.$index + '.overWeightExtraPrice'"
                        :rules="rules.overWeightExtraPrice"
                      >
                        <div style="display: flex;">
                          <div style="flex: 1">
                            <el-input v-model.trim="scope.row.overWeightExtraPrice" />
                          </div>
                          <div style="width: 35px;text-align: right;">/KG</div>
                        </div>
                      </el-form-item>
                    </template>
                  </el-table-column>
                </template>
              </template>
              <!--操作-->
              <el-table-column :label="$t('basicData.operate')" width="120">
                <template v-slot="scope">
                  <!--确定删除吗？-->
                  <el-popconfirm
                    :title="$t('basicData.AreYouSureYouWantToDelete')"
                    @confirm="handleDel(scope.$index, 'collectFeesList')"
                  >
                    <!--删除-->
                    <template #reference>
                      <el-button size="mini" type="danger">{{ $t('basicData.Delete') }}</el-button>
                    </template>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
            <!--            </virtual-scroll>-->
          </div>

          <!--增加其他规则-->
          <div>
            <div class="feet-r mb10">
              <!-- 新增特殊规则-->
              <el-button
                v-permit:remove="'btn:finance:basicData:quotationManagement:add'"
                size="small"
                type="primary"
                @click="handleAdd1()"
              >{{ $t('basicData.AddAdditionalRules') }}
              </el-button>
              <el-popover
                placement="bottom-start"
                trigger="hover"
              >
                <import-download
                  :key="exportKey"
                  :import-type="2"
                  :expense-type-list="expenseTypeList"
                  :special-fee-list="specialFeeList"
                  :insurance-type-list="insuranceTypeList"
                  :other-rules-raw-data="otherRulesRawData"
                  :table-data="{ formData, subregionList, modelList }"
                  :table-data-obj="tableDataObj.collectFeesList"
                  @importPartition="importPartition"
                />
                <!--导入/下载-->
                <template #reference>
                  <el-button plain size="small">{{ $t('basicData.ImportDownload') }}</el-button>
                </template>
              </el-popover>
              <!--清空报价-->
              <el-popover
                placement="bottom-start"
                trigger="hover"
              >
                <div class="feet">
                  <!--清空当前分区-->
                  <el-button
                    size="small"
                    type="primary"
                    @click="clearOtherOffers(1)"
                  >{{ $t('basicData.EmptyCurrentPartition') }}
                  </el-button>
                  <!--清空所有分区-->
                  <el-button
                    class="feet-btn"
                    size="small"
                    type="primary"
                    @click="clearOtherOffers(2)"
                  >{{ $t('basicData.EmptyAllPartitions') }}
                  </el-button>
                </div>
                <!--清空报价-->
                <template #reference>
                  <el-button plain size="small">{{ $t('basicData.ClearTheOffer') }}</el-button>
                </template>
              </el-popover>
            </div>
            <el-table
              :key="tableKey"
              :data="formData.feeTypeList"
              class="error-table"
              border
            >
              <!--费用类型-->
              <el-table-column :label="$t('basicData.ExpenseType')" width="200">
                <template #header>
                  <div>
                    <span style="color: red;">*</span>
                    <span>{{ $t('basicData.ExpenseType') }}</span>
                  </div>
                </template>
                <template v-slot="scope">
                  <div>
                    <el-form-item
                      :prop="'feeTypeList.' + scope.$index + '.feeTypeCode'"
                      :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                    >
                      <el-select
                        v-model="scope.row.feeTypeCode"
                        :placeholder="$t('basicData.PleaseSelect')"
                        style="width: 100%;"
                        @change="feeTypeCodeChange(scope.row.feeTypeCode, scope.$index)"
                        @focus="disabledFeeTyp"
                      >
                        <el-option
                          v-for="(item, ind) in specialFeeList"
                          :key="ind"
                          :disabled="selectFeeTypeCode.includes(item.code)"
                          :label="item.displayName"
                          :value="item.code"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <!--计费规则-->
              <el-table-column :label="$t('basicData.BillingRules')">
                <template v-slot="scope">
                  <div>
                    <div v-if="[0,9].includes(scope.row.specialRules)">
                      <div style="display: inline-block;">
                        <el-form-item
                          :prop="'feeTypeList.' + scope.$index + '.taxRate'"
                          :rules="{ required: true, suffix: 3, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                        >
                          <!--商品申报金额/发票金额-->
                          {{ scope.row.specialRules === 9 ? $t('basicData.invoiceAmount') : $t('basicData.TheAmountDeclaredForTheProduct') }} *
                          <el-input v-model="scope.row.taxRate" style="display: inline-block;width: 120px;" />
                          %
                        </el-form-item>
                      </div>
                      <div style="display: inline-block;margin-left: 20px;">
                        <!--
                          暂时不需要校验了
                          :prop="'feeTypeList.' + scope.$index + '.price'"
                          :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                        -->
                        <el-form-item>
                          <!--最低标准-->
                          {{ $t('basicData.MinimumStandards') }}
                          <el-input v-model="scope.row.price" style="display: inline-block;width: 120px;" />
                          BRL
                        </el-form-item>
                      </div>
                    </div>
                    <div v-if="scope.row.specialRules === 1">
                      <el-form-item
                        :prop="'feeTypeList.' + scope.$index + '.taxRate'"
                        :rules="{ required: true, suffix: 3, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                      >
                        <!--（快递费 + 快递税（含保险））-->
                        <span v-if="formData.businessType === 0">{{
                          '（' + $t('basicData.CourierFee') + ' + ' + $t('basicData.CourierTax') + '(ISS/ICMS)' + '（' + $t('basicData.InsuranceIncluded') + '））'
                        }}</span>
                        <!--（揽收费 + 揽收税（含保险））-->
                        <span v-if="formData.businessType === 1">{{
                          '（' + $t('basicData.CollectFees') + ' + ' + $t('basicData.CollectTaxes') + '(ISS/ICMS)' + '（' + $t('basicData.InsuranceIncluded') + '））'
                        }}</span>
                        <!--（派件费 + 派件税（含保险））-->
                        <span v-if="formData.businessType === 2">{{
                          '（' + $t('basicData.DeliveryFee') + ' + ' + $t('basicData.DeliveryTax') + '(ISS/ICMS)' + '（' + $t('basicData.InsuranceIncluded') + '））'
                        }}</span>
                        *
                        <el-input v-model="scope.row.taxRate" style="display: inline-block;width: 120px;" />
                        %
                      </el-form-item>
                    </div>
                    <div v-if="scope.row.specialRules === 2">
                      <div style="display: inline-block;">
                        <el-form-item
                          :prop="'feeTypeList.' + scope.$index + '.taxRateOne'"
                        >
                          <!--快递费-->
                          <span v-if="formData.businessType === 0">{{ $t('basicData.CourierFee') }}</span>
                          <!--揽收费-->
                          <span v-if="formData.businessType === 1">({{
                            $t('basicData.CollectFees') + ' + ' + $t('basicData.insurance')
                          }})</span>
                          <!--快递费-->
                          <span v-if="formData.businessType === 2">{{ $t('basicData.DeliveryFee') }}</span>
                          / (1 - ISS{{ $t('GlobalSetObj.rate') }})
                        </el-form-item>
                      </div>
                      *
                      <div style="display: inline-block;">
                        <el-form-item
                          :prop="'feeTypeList.' + scope.$index + '.taxRate'"
                        >
                          ISS{{ $t('GlobalSetObj.rate') }}
                        </el-form-item>
                      </div>
                    </div>
                    <div v-if="scope.row.specialRules === 3">
                      <div style="display: inline-block;">
                        <el-form-item
                          :prop="'feeTypeList.' + scope.$index + '.taxRateOne'"
                        >
                          <!--快递费-->
                          <span v-if="formData.businessType === 0">{{ $t('basicData.CourierFee') }}</span>
                          <!--揽收费-->
                          <span v-if="formData.businessType === 1">({{
                            $t('basicData.CollectFees') + ' + ' + $t('basicData.insurance')
                          }})</span>
                          <!--快递费-->
                          <span v-if="formData.businessType === 2">{{ $t('basicData.DeliveryFee') }}</span>
                          / (1 - ICMS{{ $t('GlobalSetObj.rate') }}) * ICMS{{ $t('GlobalSetObj.rate') }}
                        </el-form-item>
                      </div>
                    </div>
                    <div v-if="scope.row.specialRules === 4">
                      <div>
                        <div style="display: inline-block;">
                          <el-form-item
                            :prop="'feeTypeList.' + scope.$index + '.weight'"
                            :rules="{ required: true, suffix: 3, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                          >
                            <!--重量-->
                            {{ $t('operationCenter.Weight') }} >=
                            <el-input v-model="scope.row.weight" style="display: inline-block;width: 120px;" />
                            KG
                          </el-form-item>
                        </div>
                        <div style="display: inline-block;margin-left: 20px;">
                          <el-form-item
                            :prop="'feeTypeList.' + scope.$index + '.price'"
                            :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                          >
                            <!--增加价格-->
                            {{ $t('basicData.IncreaseThePrice') }}
                            <el-input v-model="scope.row.price" style="display: inline-block;width: 120px;" />
                            BRL
                          </el-form-item>
                        </div>
                      </div>
                    </div>
                    <!-- 5:*BRL/*KG(向上取整),   6:*BRL/票 -->
                    <div v-if="scope.row.specialRules === 5">
                      <div style="display: inline-block;">
                        <el-form-item
                          :prop="'feeTypeList.' + scope.$index + '.weight'"
                          :rules="{ required: true, suffix: 3, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                        >
                          <!-- *BRL/*KG(向上取整) -->
                          <el-input v-model="scope.row.weight" style="display: inline-block;width: 120px;" />
                          /KG（{{ $t('basicData.roundUp') }}）
                        </el-form-item>
                      </div>
                      <div style="display: inline-block;margin-left: 10px;">
                        <el-form-item
                          :prop="'feeTypeList.' + scope.$index + '.price'"
                          :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                        >
                          {{ $t('basicData.increase') }}
                          <el-input v-model="scope.row.price" style="display: inline-block;width: 120px;" />
                          BRL
                        </el-form-item>
                      </div>
                    </div>
                    <div v-if="scope.row.specialRules === 6">
                      <el-form-item
                        :prop="'feeTypeList.' + scope.$index + '.price'"
                        :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                      >
                        <!-- *BRL/票 -->
                        <el-input v-model="scope.row.price" style="display: inline-block;width: 120px;" />
                        /{{ $t('basicData.ticket') }}
                      </el-form-item>
                    </div>
                    <div v-if="scope.row.specialRules === 7">
                      <div style="display: inline-block;">
                        <el-form-item
                          :prop="'feeTypeList.' + scope.$index + '.taxRateOne'"
                        >
                          <!--快递费-->
                          <span v-if="formData.businessType === 0">{{ $t('basicData.CourierFee') }}</span>
                          <!--揽收费-->
                          <span v-if="formData.businessType === 1">({{
                            $t('basicData.CollectFees') + ' + ' + $t('basicData.insurance')
                          }})</span>
                          <!--快递费-->
                          <span v-if="formData.businessType === 2">{{ $t('basicData.DeliveryFee') }}</span> *
                          ISS{{ $t('GlobalSetObj.rate') }}
                        </el-form-item>
                      </div>
                    </div>
                    <!-- 超重额外费用/KG-->
                    <div v-if="scope.row.specialRules === 8">
                      <div>
                        <div style="display: inline-block;">
                          <el-form-item
                            :prop="'feeTypeList.' + scope.$index + '.weight'"
                            :rules="{ required: true, suffix: 3, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                          >
                            <!--重量-->
                            {{ $t('operationCenter.Weight') }} >
                            <el-input v-model="scope.row.weight" style="display: inline-block;width: 120px;" />
                            KG
                          </el-form-item>
                        </div>
                        <div style="display: inline-block;margin-left: 20px;">
                          <el-form-item
                            :prop="'feeTypeList.' + scope.$index + '.price'"
                            :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                          >
                            <!--增加价格-->
                            {{ $t('basicData.IncreaseThePrice') }}/KG
                            <el-input v-model="scope.row.price" style="display: inline-block;width: 120px;" />
                            BRL
                          </el-form-item>
                        </div>
                      </div>
                    </div>
                    <!-- 运输保险费-->
                    <div v-if="scope.row.specialRules === 10">
                      <div class="feet-r">
                        <el-form-item
                          :prop="'feeTypeList.' + scope.$index + '.ruleType'"
                          :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                        >
                          <el-select
                            v-model="scope.row.ruleType"
                            :placeholder="$t('basicData.InsuranceType')"
                            style="display: inline-block;width: 160px;"
                          >
                            <el-option
                              v-for="item in insuranceTypeList"
                              :key="item.dictValue"
                              :label="item.dictLabel"
                              :value="item.dictValue"
                            />
                          </el-select>
                        </el-form-item>
                        <!-- 开票金额-->
                        {{ $t('placeOrder.InvoiceAmount') }} *
                        <el-form-item
                          :prop="'feeTypeList.' + scope.$index + '.taxRate'"
                          :rules="{ required: true, suffix: 2, negative: '', validator: ratioType, trigger: ['blur', 'change'] }"
                        >
                          <el-input
                            v-model="scope.row.taxRate"
                            style="display: inline-block;width: 120px;"
                            :placeholder="$t('orderCenterCont.proportions')"
                          />
                          %
                        </el-form-item>
                      </div>
                    </div>
                    <!-- 体积*单价-->
                    <div v-if="scope.row.specialRules === 11">
                      <div class="feet-r">
                        <!-- 体积-->
                        {{ $t('basicData.Volume') }} *
                        <el-form-item
                          :prop="'feeTypeList.' + scope.$index + '.price'"
                          :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                        >
                          <el-input
                            v-model="scope.row.price"
                            style="display: inline-block;width: 140px;"
                            :placeholder="$t('basicData.PleaseEnterTheUnitPrice')"
                          />
                        </el-form-item>
                        <span>m^3</span>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <!--操作-->
              <el-table-column :label="$t('basicData.operate')" width="120">
                <template v-slot="scope">
                  <!--确定删除吗？-->
                  <el-popconfirm
                    :title="$t('basicData.AreYouSureYouWantToDelete')"
                    @confirm="handleDel(scope.$index, 'feeTypeList')"
                  >
                    <!--删除-->
                    <el-button slot="reference" size="mini" type="danger">{{ $t('basicData.Delete') }}</el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
      </div>
    </div>
    <div
      v-permit:remove="'btn:finance:basicData:quotationManagement:edit'"
      class="addFooter"
    >
      <!--取消-->
      <el-button @click="handleUpdatePage(false)">{{ $t('basicData.Cancel') }}</el-button>
      <!--保存-->
      <el-button type="primary" @click="submitForm">{{ $t('basicData.Save') }}</el-button>
    </div>

    <!--保存提示-->
    <el-dialog
      :append-to-body="true"
      :title="$t('basicData.tips')"
      :visible.sync="dialogVisible"
      width="400"
    >
      <div v-for="(item, ind) in errData" :key="ind" style="color: red;margin-bottom: 8px;">{{ item }}</div>
      <span slot="footer" class="dialog-footer">
        <!--确 定-->
        <el-button type="primary" @click="dialogVisible = false">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiGetAffiliateById } from '@/api/finance/partition';
import {
  apiNewOfferPriceDetail,
  apiNewListByOfferPriceId,
  apiOfferPriceAdd,
  apiOfferPriceDetailEdit,
  apiSiteQuery,
  apiProviderPage, apiGetCarLineList
} from '@/api/finance/basicData';
import { apiGetCustomerList, apiGetCustomerPage } from '@/api/finance/contasDeClientes';
import { cloneDeep, groupBy, get } from 'lodash-es';
import { VALIDATE_PRICE_OBJ, VALIDATE_OTHER_PRICE_OBJ, EXPRESS_TYPE, fromValidate, BILL_TYPE } from './utils';
import QueryPartVCmp from '@/views/finance/cmp/Query/QueryPartV2Cmp.vue';
import CollectTypeCmp from './CollectTypeCmp.vue';
import { sendBatchData } from '@/views/finance/basicData/partition/cmp/utils';
import { BUSINESS_TYPE, QUOTE_TYPE, QUOTE_MODE_TYPE, CARGO_TYPE } from '@/views/finance/enums';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';
// import VirtualScroll, { VirtualColumn } from 'el-table-virtual-scroll';

const form = {
  id: '', // 主键id
  name: '', // 报价名称
  startTime: '', // 开始时间
  businessType: null, // 业务类型
  collectionCategory: 0, // 揽收类型
  partitionId: '', // 分区方案id,
  partitionName: '', // 分区方案名称
  offerType: 1, // 报价类型 1:标准价 2:应收主体价 3:网点价 4 客户
  offerMode: 0, // 报价模式 0 区间 1 续重
  offerAttr: 1, // 使用类型 1:应收 2:应付
  cargoType: 0, // 货物类型  0：正常 1：大件
  expressType: 2, // 服务类型 1 特快 2 普快 3 邮政
  providerInfoId: '', // 应收主体
  providerInfoName: '',
  siteIds: [], // 网点id
  siteName: '', // 网点名称,
  customerIds: [], // 客户
  billType: '', // 账单类型
  collectType: '', // 揽收方式
  partitionAffiliateId: '', // 分区id
  collectFeesList: [],
  feeTypeList: [] // 其他规则列表
};

export default {
  components: {
    QueryPartVCmp,
    // VirtualScroll,
    // VirtualColumn,
    'import-download': () => import('./ImportDownload'),
    CollectTypeCmp
  },
  mixins: [toolRequestClass],
  props: {
    // 类型标识 1新增 2编辑
    operationType: {
      type: Number,
      default: 1
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    // 正负保留小数点
    const priceType = (rule, value, callback) => {
      const reg = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value !== null && value !== '' && value !== undefined) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            if (rule.package !== null && rule.package !== '' && rule.package !== undefined) {
              if (rule.negative1 === 2) {
                if (parseFloat(value) <= parseFloat(rule.package)) {
                  console.log(parseFloat(value), parseFloat(rule.package), parseFloat(value) <= parseFloat(rule.package));
                  return callback(new Error(this.$i18n.t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
                } else if (parseFloat(value) <= 0) {
                  return callback(new Error(this.$i18n.t('basicData.MustBeGreaterThan0'))); // 必须大于0
                }
              } else {
                if (parseFloat(value) >= parseFloat(rule.package)) {
                  return callback(new Error(this.$i18n.t('basicData.MustLessThanEndValue'))); // 必须小于结束值
                } else {
                  return callback();
                }
              }
            }
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value !== null && value !== '' && value !== undefined) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            if (rule.negative1 === 2) {
              if (parseFloat(value) <= parseFloat(rule.package)) {
                console.log(parseFloat(value), parseFloat(rule.package), parseFloat(value) <= parseFloat(rule.package), '//////////////');
                return callback(new Error(this.$i18n.t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
              } else if (parseFloat(value) <= 0) {
                return callback(new Error(this.$i18n.t('basicData.MustBeGreaterThan0'))); // 必须大于0
              }
            } else {
              if (parseFloat(value) >= parseFloat(rule.package)) {
                return callback(new Error(this.$i18n.t('basicData.MustLessThanEndValue'))); // 必须小于结束值
              } else {
                return callback();
              }
            }
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$i18n.t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };

    // 比例验证
    const ratioType = (rule, value, callback) => {
      const reg = /^(100(\.00?)?|[1-9]?\d(\.\d{1,2})?)$/;
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value !== null && value !== '' && value !== undefined) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            if (rule.package !== null && rule.package !== '' && rule.package !== undefined) {
              if (rule.negative1 === 2) {
                if (parseFloat(value) <= parseFloat(rule.package)) {
                  console.log(parseFloat(value), parseFloat(rule.package), parseFloat(value) <= parseFloat(rule.package));
                  return callback(new Error(this.$i18n.t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
                } else if (parseFloat(value) <= 0) {
                  return callback(new Error(this.$i18n.t('basicData.MustBeGreaterThan0'))); // 必须大于0
                }
              } else {
                if (parseFloat(value) >= parseFloat(rule.package)) {
                  return callback(new Error(this.$i18n.t('basicData.MustLessThanEndValue'))); // 必须小于结束值
                } else {
                  return callback();
                }
              }
            }
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value !== null && value !== '' && value !== undefined) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            if (rule.negative1 === 2) {
              if (parseFloat(value) <= parseFloat(rule.package)) {
                console.log(parseFloat(value), parseFloat(rule.package), parseFloat(value) <= parseFloat(rule.package), '//////////////');
                return callback(new Error(this.$i18n.t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
              } else if (parseFloat(value) <= 0) {
                return callback(new Error(this.$i18n.t('basicData.MustBeGreaterThan0'))); // 必须大于0
              }
            } else {
              if (parseFloat(value) >= parseFloat(rule.package)) {
                return callback(new Error(this.$i18n.t('basicData.MustLessThanEndValue'))); // 必须小于结束值
              } else {
                return callback();
              }
            }
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$i18n.t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };

    // 价格校验
    const priceCheck = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(this.$t('GlobalSetObj.pleaseInput'))); // 请输入
      }

      // 匹配非负数，支持整数和最多两位小数(正整数 | 0.xx | 正整数.xx)
      // const reg1 = /^(0\.[1-9]\d?|0\.\d[1-9]|[1-9]\d*\.\d{2})$/;
      // 匹配非负数，支持整数和最多两位小数(0 | 正整数 | 0.xx | 正整数.xx)
      // const reg = /^(?!0\.00$)(0|([1-9]\d*))(\.\d{1,2})?$/;
      // 业务类型为揽收业务价格可以为0，否则必须大于0
      const reg = this.formData.businessType === 1
        ? /^(?!0\.00$)(0|([1-9]\d*))(\.\d{1,2})?$/
        : /^([1-9]\d*(\.\d{1,2})?|0\.[1-9]\d?|0\.\d[1-9])$/;
      console.log(reg.test(value));
      if (reg.test(value) === false) {
        return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // '格式不正确'
      }
      return callback();
    };

    // 超出价格校验
    const overWeightExtraPriceCheck = (rule, value, callback) => {
      // 是否是数字
      if (Number.isNaN(Number(value))) {
        return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // '格式不正确'
      }
      return callback();
    };

    // 箱数验证 大于0的正整数
    const Integer0 = (rule, value, callback) => {
      let reg;
      if (rule.negative1 === 1) {
        reg = /(^[0-9]\d*$)/;
      } else {
        reg = /(^[1-9]\d*$)/;
      }
      if (rule.required) {
        if (value !== null && value !== '' && value !== undefined) {
          if (reg.test(value) === false) {
            if (rule.negative1 === 1) {
              return callback(new Error(this.$i18n.t('basicData.MustPositiveIntegerGreaterThanOrEqual0'))); // '必须是大于或等于0的正整数'
            } else {
              return callback(new Error(this.$i18n.t('basicData.MustPositiveIntegerGreaterThan0'))); // '必须是大于0的正整数'
            }
          } else {
            if (rule.package !== null && rule.package !== '' && rule.package !== undefined) {
              // 开始小于结束
              if (rule.negative1 === 1) {
                if (parseInt(value) >= parseInt(rule.package)) {
                  return callback(new Error(this.$i18n.t('basicData.MustLessThanEndValue'))); // 必须小于结束值
                } else {
                  return callback();
                }
              } else {
                if (parseInt(value) <= parseInt(rule.package)) {
                  return callback(new Error(this.$i18n.t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
                } else {
                  return callback();
                }
              }
            }
            return callback();
          }
        } else {
          return callback(new Error(this.$i18n.t('basicData.CannotBeEmpty'))); // '不能为空'
        }
      } else {
        if (value !== null && value !== '' && value !== undefined) {
          if (reg.test(value) === false) {
            if (rule.negative === 1) {
              return callback(new Error(this.$i18n.t('basicData.MustPositiveIntegerGreaterThan0'))); // '必须是大于0的正整数'
            } else {
              return callback(new Error(this.$i18n.t('basicData.MustPositiveIntegerGreaterThanOrEqual0'))); // '必须是大于或等于0的正整数'
            }
          } else {
            return callback();
          }
        } else {
          return callback();
        }
      }
    };
    // 有效期校验
    const checkBeginTime = (rule, value, callback) => {
      if (this.operationType === 2 && this.editData && this.editData.offerPriceStatus === 1) {
        callback();
      }
      if (!value) {
        return callback(new Error(this.$i18n.t('basicData.CannotBeEmpty'))); // '不能为空'
      }
      // const valTime = date2TimeStamp(value);
      // const nowTime = Date.now();
      // if (valTime <= nowTime) {
      //   return callback(new Error(this.$i18n.t('basicData.CannotBeLessThanTheCurrentDate'))); // 日期不能小于当前日期
      // }
      callback();
    };
    return {
      BUSINESS_TYPE,
      EXPRESS_TYPE,
      CARGO_TYPE,
      BILL_TYPE,
      QUOTE_TYPE,
      QUOTE_MODE_TYPE,
      rules: {
        name: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] },
          // '长度在 2 到 50 个字符'
          {
            min: 2,
            max: 50,
            message: this.$i18n.t('basicData.TheLengthBetween2And50Characters'),
            trigger: ['blur', 'change']
          }
        ],
        startTime: [
          {
            required: !(this.operationType === 2 && this.editData && this.editData.offerPriceStatus === 1),
            validator: checkBeginTime,
            trigger: ['blur', 'change']
          }
        ],
        businessType: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        partitionId: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        offerType: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        offerMode: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        offerAttr: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        providerInfoId: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        siteIds: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        customerIds: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        cargoType: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        expressType: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        billType: [
          { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        price: [
          {
            required: true,
            validator: priceCheck,
            trigger: ['blur', 'change']
          }
        ],

        overWeightExtraPrice: [
          {
            required: false,
            validator: overWeightExtraPriceCheck,
            trigger: ['blur', 'change']
          }
        ]
      },
      Integer0,
      priceType,
      ratioType,
      isFeeShow: false,
      errData: [],
      dialogVisible: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      providerList: [], // 主体
      outletsList: [], // 网点
      subregionList: [], // 分区明细
      formData: {
        ...form
      },
      tableDataObj: {
        collectFeesList: {},
        feeTypeList: {}
      },
      exportKey: new Date().getTime(),
      customerList: [],
      selectCustomer: [],
      idCustomerList: [],
      selectFeeTypeCode: [],
      tableKey: new Date().getTime(),
      otherRulesRawData: [], // 其它规则接口响应原始数据，在其它规则导出报价时使用，这是前端未处理过的数据
      feeParams: {
        state: 1, // 启用
        attribute: 1 // 应收
      }
    };
  },
  computed: {
    // 1 账单日期禁用
    isDataDisabled() {
      return this.operationType === 2 && this.editData && this.editData.offerPriceStatus === 1;
    },
    // 2 账单日期语言
    isZh() {
      return this.$i18n.locale === 'zh' ? this.zhDate : this.ptDate;
    },
    // 3 账单日期限制
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 3600 * 1000; // 不能选择生效日期在当前服务时间之前
        }
      };
    }
  },
  watch: {
    editData: {
      immediate: true,
      deep: true,
      handler(newVal) {
        console.log('newVal', newVal, Object.keys(newVal));
        if (!Object.keys(newVal).length) {
          return;
        }
        this.formData = {
          id: newVal.id,
          businessType: newVal.businessType, // 业务类型
          collectionCategory: newVal.collectionCategory, // 揽收类型
          name: newVal.name, // 报价名称
          offerType: newVal.offerType, // 报价类型 1:标准价 2:应收主体价 3:网点价 4:指定客户价
          offerMode: newVal.offerMode, // 报价模式 0 区间价 1 续重
          billType: newVal.billType, // 账单类型 0 正向 1 逆向
          offerAttr: parseInt(newVal.offerAttr), // 使用类型 1:应收 2:应付
          providerInfoId: parseInt(newVal.providerInfoId), // 应收主体
          providerInfoName: newVal.providerInfoName,
          customerIds: newVal.customerId, // 客户id
          customerName: newVal.customerName, // 客户名称
          siteIds: newVal.siteId, // 网点id
          siteName: newVal.siteName, // 网点名称,
          partitionId: newVal.partitionId, // 分区方案id,
          partitionName: newVal.partitionName, // 分区方案名称
          startTime: newVal.startTime, // 开始时间
          collectType: newVal.collectType || '', // 揽收方式
          partitionAffiliateId: newVal.partitionAffiliateId || newVal.vehicleType, // 分区/车型
          expressType: newVal.expressType, // 服务类型
          cargoType: newVal.cargoType, // 货物类型  0：正常 1：大件
          collectFeesList: [],
          feeTypeList: [] // 其他规则列表
        };
      }
    },
    // 分区变化
    'formData.partitionAffiliateId'(val) {
      if (val === undefined) return;
      // 分区
      const { collectFeesList, feeTypeList } = this.tableDataObj;

      if (Array.isArray(collectFeesList[val])) {
        this.tableDataObj.collectFeesList[val] = collectFeesList[val];
        this.formData['collectFeesList'] = collectFeesList[val];
      } else {
        // 未定义
        this.$set(this.tableDataObj.collectFeesList, val, []);
        this.formData['collectFeesList'] = [];
      }

      if (Array.isArray(feeTypeList[val])) {
        this.tableDataObj.feeTypeList[val] = feeTypeList[val];
        this.formData['feeTypeList'] = feeTypeList[val];
      } else {
        // 未定义
        this.$set(this.tableDataObj.feeTypeList, val, []);
        this.formData['feeTypeList'] = [];
      }
      // if (this.editData.customerId && this.editData.customerName) {
      //   this.selectCustomer = [{
      //     id: this.editData.customerId,
      //     customerAlias: this.editData.customerName
      //   }
      //   ];
      // }
    },
    isFeeShow(val) {
      if (val) {
        // 查看报价方案详情和其他规则
        this.asyncGetAffiliateById();
      }
    }
  },

  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      const edit = cloneDeep(this.formData);
      if (edit.id) {
        // 编辑时获取已选客户
        this.getIdSelect();
        this.selectCustomer = [
          { id: edit.customerIds, customerAlias: edit.customerName }
        ];

        // 分区方案获取分区明细
        if (edit.partitionId) {
          this.getOfferAffiliateList(edit.partitionId);
        }
        if (edit.businessType === 8) {
          this.getForSelect();
        }
        // 主体获取网点数据
        if (edit.providerInfoId) {
          this.getSiteQuery(edit.providerInfoId);
        }
        this.exportKey = new Date().getTime();
      }
      // 获取分区方案
      this.queryPartitionList();
      // 获取客户
      this.getCustomerPage();
      // 获取应收主体选项
      this.queryProviderPage();
      // 获取费用类型
      this.queryFeeTypeList();
    },
    // 清空其他规则报价
    clearOtherOffers(type) {
      // type 1:清空当前分区 2:清空所有分区
      if (type === 1) {
        const { partitionAffiliateId } = this.formData;
        this.formData['feeTypeList'] = [];
        this.tableDataObj.feeTypeList[partitionAffiliateId] = [];
      } else {
        this.subregionList.map(item => {
          this.tableDataObj.feeTypeList[item.id] = [];
        });
        this.formData['feeTypeList'] = [];
      }
    },
    // 清空报价
    clearOffers(type) {
      // type 1:清空当前分区 2:清空所有分区
      if (type === 1) {
        const { partitionAffiliateId } = this.formData;
        this.formData['collectFeesList'] = [];
        this.tableDataObj.collectFeesList[partitionAffiliateId] = [];
      } else {
        this.subregionList.map(item => {
          this.tableDataObj.collectFeesList[item.id] = [];
        });
        this.formData['collectFeesList'] = [];
      }
    },
    // 获取已选费用类型code  =>
    disabledFeeTyp() {
      this.selectFeeTypeCode = [];
      const dataCode = []; // ['FY005', 'FY006', 'FY007', 'FY008', 'FY009', 'FY011'];
      this.specialFeeList.map(item => {
        if (dataCode.includes(item.code) === false) {
          dataCode.push(item.code);
        }
      });
      this.formData.feeTypeList.map(item => {
        if (dataCode.includes(item.feeTypeCode) === true) {
          if (this.selectFeeTypeCode.includes(item.feeTypeCode) === false) {
            this.selectFeeTypeCode.push(item.feeTypeCode);
          }
        }
      });
    },
    // 其他规则费用类型变化
    feeTypeCodeChange(code, index) {
      this.specialFeeList.map(item => {
        if (code === item.code) {
          this.formData.feeTypeList[index].specialRules = item.specialRules;
        }
      });
    },

    // 计费类型变化判断同一费用类型是否存在多种计费类型
    chargeTypeChange(scope) {
      this.formData.collectFeesList.map((item, ind) => {
        if (ind !== scope.$index) {
          if (item.feeTypeCode && (item.feeTypeCode === scope.row.feeTypeCode)) {
            if (item.billingType && (item.billingType !== scope.row.billingType)) {
              this.$message.warning(this.$t('basicData.ThereCantBeDifferentBillingTypesForTheSameChargeType')); // '同一费用类型不能存在相同计费类型'
              this.formData.collectFeesList[scope.$index].billingType = '';
            }
          }
        }
      });
    },

    // 获取分区方案详情
    getOfferAffiliateList(id) {
      apiGetAffiliateById(id, false).then(res => {
        if (res.code === 200) {
          this.subregionList = res.data.partitionAffiliateList || [];
          this.formData.partitionAffiliateId = this.subregionList[0].id;
          // 获取分区后-获取分区关联报价详情
          this.isFeeShow = true;
        }
      });
    },
    // 整车业务初始化车型
    async getForSelect() {
      try {
        apiGetCarLineList().then(res => {
          if (res.code === 200) {
            this.modelList = res.data.filter(item => !['1', '10', '11', '12'].includes(item.dictValue)) || [];
          }
          if (this.modelList && this.modelList.length > 0) {
            this.formData.partitionAffiliateId = this.modelList[0].dictValue;
          }
          this.isFeeShow = true;
        });

        this.getInsuranceType('insurance_type');
      } catch (error) {
        console.error('获取选项数据失败:', error);
      }
    },

    /**
     * 切换业务类型
     * @param type 1 业务类型 2 揽收类型
     */
    changeBusinessType(type) {
      const { businessType } = this.formData;
      if (type === 1) {
        this.formData.collectionCategory = businessType === 1 ? 0 : '';
        this.formData.offerType = businessType === 8 ? 4 : '';
        this.formData.offerMode = businessType === 8 ? 0 : '';

        // 切换业务类型重新获取费用类型
        this.queryFeeTypeList();
        if (businessType === 8) {
          // 获取客户
          this.getCustomerPage();
          // 获取车型
          this.getForSelect();
        }
      }
      // this.formData.partitionId = '';
      // this.formData.partitionName = '';
      // 切换业务类型清空报价详情
      this.formData['collectFeesList'] = [];
      this.formData['feeTypeList'] = [];
      this.tableDataObj = {
        collectFeesList: {},
        feeTypeList: {}
      };
      this.tableKey = new Date().getTime();
      // 重置form校验
      this.$nextTick(() => {
        this.$refs.queryForm.clearValidate();
      });
    },

    /**
     *  切换分区方案清空价格详情和其他规则数据
     */
    getOtherFeeDetail() {
      if (this.formData.partitionId) {
        this.partitionList.map(item => {
          if (item.id === this.formData.partitionId) {
            this.formData.partitionName = item.name;
          }
        });
      } else {
        this.formData.partitionName = '';
      }
      this.formData['collectFeesList'] = [];
      this.formData['feeTypeList'] = [];
      this.tableDataObj = {
        collectFeesList: {},
        feeTypeList: {}
      };
      // 切换分区重置状态
      this.isFeeShow = false;
      // 获取分区明细
      this.getOfferAffiliateList(this.formData.partitionId);
      // 重置分区明细数据
      // this.subregionList.map(item => {
      //   this.tableDataObj.collectFeesList[item.id] = [];
      //   this.tableDataObj.feeTypeList[item.id] = [];
      // });
    },
    /**
     * 主体切换获取站点列表数据
     * @param val 主体id
     */
    providerInfoChange(val) {
      this.formData.siteIds = [];
      this.formData.siteName = '';
      this.formData.providerInfoName = '';
      this.outletsList = [];
      this.providerList.map(item => {
        if (item.id === val) {
          this.formData.providerInfoName = item.name;
        }
      });
      if (val) {
        // 获取站点
        this.getSiteQuery(val);
      }
    },
    /**
     * 切换报价类型
     */
    offerTypeChange() {
      this.formData.siteIds = [];
      this.formData.siteName = '';
      this.formData.providerInfoId = '';
      this.formData.providerInfoName = '';
      this.formData.customerIds = [];
      this.selectCustomer = [];
    },
    /**
     * 获取网点信息
     * @param id 主体id
     */
    getSiteQuery(id) {
      apiSiteQuery(id, false).then(res => {
        if (res.code === 200) {
          this.outletsList = res.data;
        }
      });
    },
    /**
     * 编辑时获取客户id列表数据
     */
    getIdSelect() {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          id: this.formData.customerIds
        }
      };
      apiGetCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.idCustomerList = res.data.records;
          if (this.selectCustomer.length > 0) {
            this.idCustomerList.unshift(...this.selectCustomer);
          }
        }
      });
    },
    /**
     * 获取客户列表数据
     * @param name 客户名称
     */
    // getCustomerPage(name = '') {
    //   let param;
    //   const { customerIds, businessType } = this.formData;
    //   const API = businessType === 8 ? apiGetCustomerList : apiGetCustomerPage;
    //   if (businessType === 8) {
    //     param = {
    //       username: name
    //     };
    //   } else {
    //     param = {
    //       pageSize: 10,
    //       pageNumber: 1,
    //       params: {
    //         quickSearch: name
    //       }
    //     };
    //   }
    //   API(param).then((res) => {
    //     const { code, data } = res;
    //     const ids = [];
    //     if (code === 200) {
    //       const Arr = businessType === 8 ? data : data.records;
    //       Arr.forEach(item => {
    //         ids.push(item.id);
    //       });
    //       if (customerIds && ids.includes(customerIds) === false) {
    //         if (this.idCustomerList) {
    //           Arr = [...this.idCustomerList, ...Arr];
    //         }
    //       }
    //       this.customerList = Arr;
    //     }
    //   });
    // },
    getCustomerPage(name = '') {
      let param;
      const { customerIds, businessType } = this.formData;
      const isSpecialType = businessType === 8;
      const API = isSpecialType ? apiGetCustomerList : apiGetCustomerPage;

      if (isSpecialType) {
        param = {
          username: name
        };
      } else {
        param = {
          pageSize: 10,
          pageNumber: 1,
          params: {
            quickSearch: name
          }
        };
      }
      API(param)
        .then((res) => {
          const { code, data } = res;
          if (code !== 200) return;

          const Arr = isSpecialType ? data : data?.records || [];
          const ids = Arr.map(item => item.id);

          const customerIdArray = Array.isArray(customerIds) ? customerIds : [customerIds].filter(id => id != null);

          const missingCustomers = customerIdArray.some(id => !ids.includes(id)) && this.idCustomerList;

          let finalList = Arr;
          if (missingCustomers) {
            finalList = [...this.idCustomerList, ...Arr];
          }

          this.customerList = finalList;
        })
        .catch(error => {
          console.error('获取客户列表失败:', error);
        });
    },
    /**
     * 切换客户
     */
    customerChange() {
      if (this.formData.id) {
        // 编辑客户单选
        this.selectCustomer = [];
        this.customerList.forEach(item => {
          if (item.id === this.formData.customerIds) {
            this.selectCustomer.push({
              id: item.id,
              customerAlias: item.customerAlias
            });
          }
        });
      } else {
        // 新增客户多选
        if (!this.formData.customerIds || this.formData.customerIds.length === 0) {
          this.selectCustomer = [];
          return;
        }

        const selectedCus = new Set();
        this.selectCustomer.forEach(item => {
          if (this.formData.customerIds.includes(item.id)) {
            selectedCus.add(JSON.stringify({
              id: item.id,
              customerAlias: item.customerAlias
            }));
          }
        });

        this.customerList.forEach(item => {
          if (this.formData.customerIds.includes(item.id)) {
            selectedCus.add(JSON.stringify({
              id: item.id,
              customerAlias: item.customerAlias
            }));
          }
        });

        this.selectCustomer = Array.from(selectedCus).map(item => JSON.parse(item));
      }
    },
    /**
     * 获取费用类型列表
     */
    // 增加报价
    handleAdd() {
      const isBool = this.isVerify();
      console.log(isBool);
      if (isBool) { return; }

      const obj = {
        ...VALIDATE_PRICE_OBJ,
        partitionAffiliateId: this.formData.partitionAffiliateId // 分区
      };
      this.formData['collectFeesList'].push(obj);
      const { partitionAffiliateId } = this.formData;
      console.log(obj, '11111111', partitionAffiliateId);
      console.log(this.formData);
      // 分区
      this.$set(this.tableDataObj.collectFeesList, partitionAffiliateId, this.formData['collectFeesList']);
      console.log(this.tableDataObj.collectFeesList);
      this.exportKey = new Date().getTime();
    },
    // 增加其他规则
    handleAdd1() {
      const { partitionAffiliateId } = this.formData;
      const isBool = this.isVerify();
      console.log(isBool);
      if (isBool) { return; }
      const obj = {
        ...VALIDATE_OTHER_PRICE_OBJ,
        partitionAffiliateId // 分区/车型
      };
      this.formData['feeTypeList'].push(obj);

      // 分区
      this.$set(this.tableDataObj.feeTypeList, partitionAffiliateId, this.formData['feeTypeList']);
      this.exportKey = new Date().getTime();
    },
    // 添加分区校验
    isVerify() {
      const { businessType, partitionAffiliateId } = this.formData;
      // 分区校验
      if (businessType !== 8) {
        // 分区不存在
        const isBool = this.isCheckPartitionId();
        if (!isBool) {
          return true;
        }
      }
      // 车型校验
      if (businessType === 8) {
        if (!partitionAffiliateId) {
          this.$message.warning(this.$t('basicData.CannotBeEmpty'));
          return true;
        }
        return false;
      }
      return false;
    },
    // 导入价格详情
    importPartition(arr, type) {
      const { businessType } = this.formData;
      if (businessType !== 8) {
        // 校验导入的分区是否存在当前分区or车型中，如果不存终止导入，同时提示
        const isBool = this.isCheckPartition(arr);
        // 分区不存在，终止导入
        if (!isBool) {
          return;
        }
      } else {
        // 校验车型是否存在
        if (!this.modelList.length) {
          this.$message.warning(this.$t('basicData.vehicleModelCannotBeEmpty'));
          return;
        }
      }

      // type 1: 普通价格详情 2: 其他规则
      if (type === 1) {
        this.importPartitionNormal(arr);
      } else {
        this.importPartitionOther(arr);
      }
    },
    // 分区是否存在
    isCheckPartitionId() {
      const { subregionList } = this;
      const str2 = this.$i18n.t('operationCenter.partition');// 分区
      const str = this.$i18n.t('basicData.CannotBeEmpty');// 不能为空

      // 分区不存在
      if (!subregionList || subregionList.length === 0) {
        this.$message.warning(str2 + str);
        return false;
      }
      return true;
    },

    // 分区校验 导入分区是否存在
    isCheckPartition(arr) {
      const { subregionList } = this;

      // 分区不存在
      {
        const isBool = this.isCheckPartitionId();
        if (!isBool) {
          return false;
        }
      }

      // 导入的所有分区
      const partitionAffiliateIdArr = arr.map(item => Number(item.partitionAffiliateId));
      const idArr = subregionList.map(item => item.id);

      const isBool = partitionAffiliateIdArr.every(item => {
        return idArr.includes(item);
      });
      // return isBool;

      // 分区不存在，终止导入
      if (!isBool) {
        this.$message.warning(this.$t('basicData.templatePartition'));
        return false;
      }
      return true;
    },

    // 导入价格详情之普通价格详情
    importPartitionNormal(arr) {
      console.log(arr, '报价导入');
      const { partitionAffiliateId } = this.formData;

      // 将数据填充
      const list = arr.map(item => {
        return {
          ...VALIDATE_PRICE_OBJ,
          ...item
        };
      });

      // 按照分区分组
      const groupByList = groupBy(list, 'partitionAffiliateId');

      Object.entries(groupByList).forEach(item => {
        const [id, list] = item;
        this.$set(this.tableDataObj.collectFeesList, id, list);
      });
      this.formData['collectFeesList'] = this.tableDataObj.collectFeesList[partitionAffiliateId] || [];
      this.exportKey = new Date().getTime();
      this.$message.success(this.$t('operationCenter.TheImportWasSuccessful')); // 导入成功
    },

    // 导入其他规则
    importPartitionOther(arr) {
      const { partitionAffiliateId } = this.formData;

      console.log(arr, '其他规则导入');

      // 将数据回填到
      const list = arr.map(item => {
        return {
          ...VALIDATE_PRICE_OBJ,
          ...item
        };
      });

      console.log(list, 'list');
      const groupByList = groupBy(list, 'partitionAffiliateId');
      const feeTypeList = this.tableDataObj.feeTypeList;
      Object.entries(groupByList).forEach(([id, list]) => {
        feeTypeList[id] = list;
      });
      console.log(this.tableDataObj.feeTypeList, '特殊规则');
      this.formData['feeTypeList'] = feeTypeList[partitionAffiliateId] || [];
      this.exportKey = new Date().getTime();
      this.$message.success(this.$t('operationCenter.TheImportWasSuccessful')); // 导入成功
    },

    // 删除分区
    handleDel(index, type) {
      const { partitionAffiliateId } = this.formData;
      this.formData[type].splice(index, 1);
      this.tableDataObj[type][partitionAffiliateId] = this.formData[type];
      this.exportKey = new Date().getTime();
    },
    // 取消
    handleUpdatePage(type) {
      this.$emit('saveData', type);
    },
    // 查看报价方案详情和其他规则
    asyncGetAffiliateById() {
      const { id, businessType } = this.formData;
      // const ids = this.formData.id;
      const parList = businessType === 8 ? this.modelList : this.subregionList;
      // ids不存在
      if (!id) return;
      // 报价详情
      const { partitionAffiliateId } = this.formData;
      sendBatchData(businessType, id, parList, 1000, apiNewOfferPriceDetail, 1).then(res => {
        const { allSuccessful, data } = res;
        console.log(allSuccessful, data, '报价详情');
        const cargoLayer = this.tableDataObj.collectFeesList;
        if (allSuccessful && data?.length > 0) {
          data.forEach((item) => {
            const partitionId = businessType === 8 ? item.vehicleType : item.partitionAffiliateId; // 分区明细id
            item.partitionAffiliateId = businessType === 8 ? item.vehicleType : item.partitionAffiliateId;
            if (cargoLayer[partitionId] === undefined) {
              this.$set(cargoLayer, partitionId, [item]);
            } else {
              cargoLayer[partitionId].push(item);
            }
          });
          // 默认展示分区明细第一条数据，如果没有查到，则展示空数组
          this.formData['collectFeesList'] = this.tableDataObj.collectFeesList[partitionAffiliateId] || [];
          this.exportKey = new Date().getTime();
        }
      }).catch(err => {
        console.log(err);
      });
      // 其他报价
      sendBatchData(businessType, id, parList, 1000, apiNewListByOfferPriceId, 2).then(res => {
        const { allSuccessful, data } = res;
        console.log(allSuccessful, data, '其他报价详情');
        if (allSuccessful) {
          if (data && data.length > 0) {
            this.otherRulesRawData = data;
            const otherData = this.tableDataObj.feeTypeList;
            data.map((item) => {
              const partitionId = businessType === 8 ? item.vehicleType : item.partitionAffiliateId; // 分区明细id
              item.partitionAffiliateId = businessType === 8 ? item.vehicleType : item.partitionAffiliateId;
              if (otherData[partitionId] === undefined) {
                this.$set(otherData, partitionId, [item]);
              } else {
                otherData[partitionId].push(item);
              }
            });
          }
          this.formData['feeTypeList'] = this.tableDataObj.feeTypeList[partitionAffiliateId] || [];
          this.exportKey = new Date().getTime();
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 校验列表数据
    verificationTable() {
      let tableForm1 = false;

      // 校验当前分区
      this.$refs.tableForm1.validate((tabRules) => {
        tableForm1 = tabRules;
      });

      // 校验所有分区
      {
        const [isBool, str] = fromValidate(this.tableDataObj, this.formData, this.subregionList);

        // 校验不通过
        if (!isBool) {
          this.$message.warning(str);
          return false;
        }
      }

      return tableForm1;
    },
    /**
     * 报价更新提交
     */
    submitForm() {
      console.log('报价更新提交');
      this.errData = [];
      this.$refs.queryForm.validate((valid) => {
        if (!valid) {
          return false;
        }

        // 校验不通过
        if (!this.verificationTable()) {
          return false;
        }

        // 网点字段处理
        let siteIds = '';
        {
          const { siteIds: ids } = this.formData;
          if (Array.isArray(ids)) {
            siteIds = ids.join(',');
          } else {
            siteIds = ids;
          }
        }

        const param = {
          name: this.formData.name,
          offerType: this.formData.offerType,
          offerMode: this.formData.offerMode,
          offerAttr: this.formData.offerAttr,
          billType: this.formData.billType,
          collectType: this.formData.collectType,
          providerInfoId: this.formData.providerInfoId,
          providerInfoName: this.formData.providerInfoName,
          siteIds,
          siteName: this.formData.siteName,
          partitionId: this.formData.partitionId,
          partitionName: this.formData.partitionName,
          startTime: this.formData.startTime,
          businessType: this.formData.businessType,
          collectionCategory: this.formData.collectionCategory,
          customers: this.selectCustomer,
          expressType: this.formData.expressType, // 快递类型
          cargoType: this.formData.cargoType, // 货物类型  0：正常 1：大件
          detailList: [],
          otherRulesList: []
        };

        const { collectFeesList, feeTypeList } = this.tableDataObj;
        console.log(collectFeesList, 'collectFeesList', feeTypeList, this.selectCustomer);

        // const jxData = (data, type) => {
        //   Object.values(data).forEach(item => {
        //     const arr = Object.values(item).filter(key => {
        //       return Object.values(key).length !== 0;
        //     });
        //     if (arr.length !== 0) {
        //       arr.forEach(items => {
        //         item.vehicleType = item.partitionAffiliateId;
        //         param[type].push(items);
        //       });
        //     }
        //   });
        // };
        const { businessType } = this.formData;
        const jxData = (data, type) => {
          if (!data || !type) {
            return;
          }

          Object.values(data).forEach(item => {
            const arr = Object.values(item).filter(key => {
              return key && typeof key === 'object' && Object.values(key).length !== 0;
            });

            if (arr.length !== 0) {
              arr.forEach(items => {
                // 设置车辆类型属性
                param[type].push({
                  ...items,
                  vehicleType: items.partitionAffiliateId
                });
              });
            }
          });
        };

        jxData(collectFeesList, 'detailList');
        jxData(feeTypeList, 'otherRulesList');

        console.log(param, '---------***********--------');
        // return;
        // 校验：在一个分区呢不能出现其他规则报价有数据，而基础报价不存在数据
        {
          const { subregionList } = this;
          const { detailList, otherRulesList } = param;
          const detailListPartitionAffiliateIdArr = detailList.filter(e => e.partitionAffiliateId !== 0).map(item => Number(item.partitionAffiliateId));
          const otherRulesListPartitionAffiliateIdArr = otherRulesList.filter(e => e.partitionAffiliateId !== 0).map(item => Number(item.partitionAffiliateId));
          console.log(detailListPartitionAffiliateIdArr, 'detailListPartitionAffiliateIdArr');
          const arr = otherRulesListPartitionAffiliateIdArr.filter(item => {
            return !detailListPartitionAffiliateIdArr.includes(item);
          });
          if (arr.length > 0 && businessType !== 8) {
            const str1 = this.$t('basicData.TypeOfCourier');// 快递类型
            const str2 = this.$t('placeOrder.cargoType');// 货物类型
            const str3 = this.$t('operationCenter.partition');// 分区
            const str4 = this.$t('customerManagements.notNull');// 不能为空

            const msgErrorArr = otherRulesList.filter(item => {
              return arr.includes(Number(item.partitionAffiliateId));
            }).map(item => {
              const y1 = get(EXPRESS_TYPE, `${item.expressType}.name`, ''); // 快递类型
              const y2 = get(CARGO_TYPE, `${item.cargoType}.name`, ''); // 货物类型
              const y3 = subregionList.find(key => key.id === Number(item.partitionAffiliateId))?.partitionIdentifier ?? '';

              return `${str1}【${y1}】，${str2}【${y2}】，${str3}【${y3}】${str4}`;
            });
            if (msgErrorArr.length > 0) {
              this.errData.push(...msgErrorArr);
              this.dialogVisible = true;
            }
            return;
          }
        }

        if (this.errData.length > 0) {
          this.dialogVisible = true;
          return;
        }
        console.log(param, '提交报价数据');
        // 报价明细费用价格为0，给出弹窗提示
        const regList = param.detailList;
        const isDialog = regList.every(item => /^0$/.test(item.price));
        if (isDialog) {
          this.asyncDialogVisible(param);
        } else {
          this.saveQuotation(param);
        }
      });
    },
    /**
     * 保存报价
     * params 参数
     */
    saveQuotation(params) {
      // 1 新增 2 编辑 3 复制新增
      const API = this.operationType === 2 ? apiOfferPriceDetailEdit : apiOfferPriceAdd;
      params.id = this.formData.id;
      API(params).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          this.$emit('saveData', true);
        }
      });
    },
    // 费用弹窗提示
    asyncDialogVisible(params) {
      this.$confirm(this.$t('receivablePayable.confirmSaveZeroPriceFee'), this.$t('basicData.tips'), { // '报价明细费用价格为0，给出弹窗提示' 提示
        confirmButtonText: this.$t('collectionCenter.Confirm'), // 确认
        cancelButtonText: this.$t('basicData.Cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        this.saveQuotation(params);
        this.dialogVisible = false;
      }).catch(err => {
        console.error(err);
      });
    },
    // 查询主体
    queryProviderPage(name = '') {
      const { providerInfoId, providerInfoName } = this.formData;
      apiProviderPage({
        pageSize: 10,
        pageNumber: 1,
        params: {
          providerBody: name,
          state: 1
        }
      }).then(res => {
        const { code, data } = res;
        const list = data.records;
        if (code === 200) {
          if (this.operationType !== 1) {
            const exists = list.some(item => item.id === providerInfoId);
            console.log(exists, providerInfoId);
            if (providerInfoId && !exists) {
              list.unshift({
                id: providerInfoId,
                providerName: providerInfoName
              });
            }
          }
          this.providerList = list;
        }
      });
    },
    // 获取费用类型
    queryFeeTypeList() {
      this.getExpenseTypeList({
        ...this.feeParams,
        businessType: this.formData.businessType
      });
    },
    /**
     * 分区方案下拉
     */
    queryPartitionList() {
      this.getSubregionData(1);
    },

    /**
     * 判断是否禁用
     * @param value 值
     * @param type 1 报价类型 2 报价模式
     * @returns {boolean}
     */
    isOptionDisabled(value, type) {
      const { businessType } = this.formData;
      if (type === 1) {
        return [2, 3].includes(value) && businessType === 8;
      } else if (type === 2) {
        return value === 1 && businessType === 8;
      }
      return false;
    }
  }
};
// 添加key
// function addKey(data) {
//   return data.map((item, index) => {
//     item.key = `item-${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${index}`;
//     return item;
//   });
// }
// 移除key
// function removeKey(data, key) {
//   return data.map(obj => {
//     // 使用对象解构赋值创建新对象，并排除要移除的属性
//     const { [key]: _, ...newObj } = obj;
//     return newObj;
//   });
// }

</script>

<style scoped>
.addFormBox {
  padding: 20px;
  height: calc(100vh - 100px);
  overflow-y: auto;
}

.addFooter {
  border-top: 1px solid #ccc;
  text-align: right;
  padding: 10px;
}

.title {
  padding: 15px 10px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
}
</style>
